import { isFarmBasedPolicyType } from '@ourbranch/policy-types';

/**
 * Shared credit-card-fee gating for the payment surfaces (manual charge form, pay-ahead) — #35705.
 *
 * A stored payment method is a credit card when it carries a card `brand`; bank/ACH methods carry a
 * `bankName` instead (the same brand-vs-bankName signal the dropdowns and the GraphQL `type` field
 * use). The processing fee itself is only relevant for a card payment on a farm-based policy (F/Z/Y)
 * for a brand that opts in (Forreston/CFM — `supportedFees.creditCard`), mirroring the backend gate
 * in @ourbranch/fee-utils generateFee / billing computeTransactionFee.
 *
 * These drive disclosure copy ONLY: since #35705 the fee is never ADDED on top of a manual/pay-ahead
 * charge — the member is billed exactly the amount shown (the fee is already baked into the policy's
 * schedule and, on imported terms, offset by an account credit).
 */
export const isCardPaymentMethod = (method) => !!method?.brand && !method?.bankName;

/**
 * Whether this policy/brand charges the CC processing fee at all — independent of any chosen method.
 * Use at payment-SETUP (adding/choosing a payment method, before a method exists) to decide whether to
 * tell the member a card incurs the fee and bank/ACH avoids it (#35705).
 */
export const creditCardFeeAppliesToPolicy = ({ policyType, brandConfig }) =>
  isFarmBasedPolicyType(policyType) && !!brandConfig?.supportedFees?.creditCard;

export const creditCardFeeApplies = ({ method, policyType, brandConfig }) =>
  isCardPaymentMethod(method) && creditCardFeeAppliesToPolicy({ policyType, brandConfig });
